import React from 'react';
import '../styles/Mural.css';
import logo from '../assets/logo.png';

function Mural() {
  const scrollToAccordion = () => {
    const accordionSection = document.getElementById('about');
    if (accordionSection) {
      accordionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="mural">
      <div className="mural-left">
        <p className="mural-text">Conquiste clientes a partir da beleza de sua marca</p>
        <p className="mural-subtext">
          Uma identidade visual forte chama atenção, transmite confiança e deixa sua marca inesquecível.
        </p>
        <button className="mural-button" onClick={scrollToAccordion}>Saiba mais</button>
      </div>
      <div className="mural-right">
        <img src={logo} alt="Logo" className="mural-logo" />
      </div>
    </div>
  );
}

export default Mural;
